import { parse } from 'node-html-parser';
import { AnchorBehavior } from '../organisms/LegalConsents/LegalConsents.types';

interface Props {
  label: string;
  anchorBehavior: AnchorBehavior;
  ariaWindowText: string | null;
  ariaModalText: string | null;
}
export function getEnhancedLinksForNewTab({ label, ariaWindowText }: Props) {
  const root = parse(label);
  const links = root.querySelectorAll('a');
  links.forEach(link => {
    link.setAttribute('target', '_blank');
    link.removeAttribute('data-is-modal');
    // Avoid adding multiple spans if already added
    const alreadyHasNote = link.querySelector('.icon-external-arrow');
    if (!alreadyHasNote) {
      link.insertAdjacentHTML(
        'beforeend',
        `<span class="d-inline-block ml-1 icon icon-external-arrow" aria-atomic="true" aria-label="${ariaWindowText}"></span>`
      );
    }
  });

  return root.toString();
}

export function getEnhancedLinksForDefault({ label, ariaModalText, ariaWindowText }: Props) {
  const root = parse(label);
  const links = root.querySelectorAll('a');
  links.forEach(link => {
    // Avoid adding multiple spans if already added
    const alreadyHasNote = link.querySelector('.icon-external-arrow');
    if (!alreadyHasNote) {
      const isModal = link.getAttribute('data-is-modal') === 'true';
      const isNewWindow = link.getAttribute('target') === '_blank';

      if (isModal || isNewWindow) {
        const text = isModal ? ariaModalText : ariaWindowText;
        const arrowClassName = isModal ? 'd-inline-block' : 'd-inline-block ml-1 icon icon-external-arrow';
        link.insertAdjacentHTML(
          'beforeend',
          `<span class="${arrowClassName}" aria-atomic="true" aria-label="${text}"></span>`
        );
      }
    }
  });

  return root.toString();
}

export function getEnhancedLabel(props: Props) {
  return props.anchorBehavior === 'newTab'
    ? getEnhancedLinksForNewTab({ ...props })
    : getEnhancedLinksForDefault({ ...props });
}
